import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardRoute } from './dashboard.route';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../shared';
import { entityName, RoleStatusDataService } from '../data-services/dashboard/status/role-status.data-service';
import { EntityDataService } from '@ngrx/data';

@NgModule({
    // declarations: [],
    providers: [RoleStatusDataService],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule.forChild({
            states: [DashboardRoute]
        })
    ]
})
export class DashboardModule {
    constructor(
        entityDataService: EntityDataService,
        roleStatusDataService: RoleStatusDataService
    ) {
        entityDataService.registerService(entityName, roleStatusDataService);
    }
}
